import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
import React, { Fragment, memo } from 'react';
import { jsx } from '@emotion/react';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { COMPONENT_NAME } from '../common/constants';
import { LinkPickerSessionProvider } from '../controllers/session-provider';
import { name as packageName, version as packageVersion } from '../version.json';
import { ErrorBoundary } from './error-boundary';
import { LoaderFallback } from './loader-fallback';
import { MessagesProvider } from './messages-provider';
import { fixedWidthContainerStyles } from './styled';
export var testIds = {
  linkPickerRoot: 'link-picker-root'
};
export var PACKAGE_DATA = {
  packageName: packageName,
  packageVersion: packageVersion,
  componentName: COMPONENT_NAME,
  source: COMPONENT_NAME
};
var LazyLinkPicker = lazyForPaint(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_link-picker" */
  './link-picker').then(function (_ref) {
    var LinkPicker = _ref.LinkPicker;
    return {
      default: LinkPicker
    };
  });
});
var DefaultRootComponent = function DefaultRootComponent(_ref2) {
  var children = _ref2.children;
  return jsx("div", {
    "data-testid": testIds.linkPickerRoot
  }, children);
};
var FixedWidthContainer = function FixedWidthContainer(props) {
  return jsx("div", _extends({
    css: fixedWidthContainerStyles
  }, props));
};
export var ComposedLinkPicker = /*#__PURE__*/memo(function (props) {
  var component = props.component;
  var RootComponent = component !== null && component !== void 0 ? component : DefaultRootComponent;

  /**
   * When ff enabled: root container will provide width to component + loader + error boundary
   * When ff disabled: component + loader + error boundary each providing their own width
   * Cannot make this change easier at risk of regression as external adopters may have css override on the form element
   */
  var RootFixedWidthContainer = getBooleanFF('platform.linking-platform.link-picker.fixed-height-search-results') ? FixedWidthContainer : Fragment;
  var LoaderFallbackContainer = getBooleanFF('platform.linking-platform.link-picker.fixed-height-search-results') ? Fragment : FixedWidthContainer;
  return jsx(AnalyticsContext, {
    data: PACKAGE_DATA
  }, jsx(LinkPickerSessionProvider, null, jsx(MessagesProvider, null, jsx(RootFixedWidthContainer, null, jsx(ErrorBoundary, null, jsx(LazySuspense, {
    fallback: jsx(LoaderFallbackContainer, null, jsx(LoaderFallback, {
      hideDisplayText: props.hideDisplayText,
      isLoadingPlugins: props.isLoadingPlugins,
      plugins: props.plugins
    }))
  }, jsx(RootComponent, _extends({}, props, {
    "data-testid": testIds.linkPickerRoot
  }), jsx(LazyLinkPicker, props))))))));
});